let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8tzTI")).then(() => parcelRequire('1mgPR'));